import { Button } from '@mui/material';
import { PrimaryButton } from '../../../../components/style/ButtonStyle';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { useNavigate } from 'react-router-dom';

export function AddUserButton({ isDesktop, onSubmit, postUserResult }: any) {
  const navigate = useNavigate();
  return (
    <>
      {isDesktop ? (
        <PrimaryButton sx={{ width: 130, height: 40 }} onClick={onSubmit}>
          저장
        </PrimaryButton>
      ) : (
        <Button variant="text" onClick={onSubmit}>
          저장
        </Button>
      )}

      <ApiResultModal
        apiResult={postUserResult}
        successTitle="등록됐습니다."
        successCode={201}
        onSuccessClose={() => {
          navigate(`/users`);
        }}
        failTitle="관리자에게 문의해주세요."
        ErrorCodeTable={{
          PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          DUPLICATE_EMAIL: { title: '이미 등록된 아이디입니다.' },
          DUPLICATE_USER: { title: '이미 사용중인 ID 입니다.' },
        }}
      />
    </>
  );
}
